var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.7V14.4C20 17.55 18.2 18.9 15.5 18.9H6.5C3.8 18.9 2 17.55 2 14.4V9C2 5.85 3.8 4.5 6.5 4.5H9.2C9.07 4.88 9 5.3 9 5.75V9.65002C9 10.62 9.32 11.44 9.89 12.01C10.46 12.58 11.28 12.9 12.25 12.9V14.29C12.25 14.8 12.83 15.11 13.26 14.83L16.15 12.9H18.75C19.2 12.9 19.62 12.83 20 12.7Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5.75V9.65002C22 11.14 21.24 12.26 20 12.7C19.62 12.83 19.2 12.9 18.75 12.9H16.15L13.26 14.83C12.83 15.11 12.25 14.8 12.25 14.29V12.9C11.28 12.9 10.46 12.58 9.89 12.01C9.32 11.44 9 10.62 9 9.65002V5.75C9 5.3 9.07 4.88 9.2 4.5C9.64 3.26 10.76 2.5 12.25 2.5H18.75C20.7 2.5 22 3.8 22 5.75Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3999 22.5H14.5999",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18.8999V22.4999",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4955 7.75H18.5045",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6957 7.75H15.7047",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8954 7.75H12.9044",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceMessage);
export default __webpack_public_path__ + "static/media/device_message.db3df5f1055fb314953733206c32cdd9.svg";
export { ForwardRef as ReactComponent };